import { MaybeRefOrGetter, toValue } from 'vue'
import { SiteID } from '../../sites/models/site'
import { useQuery } from '@tanstack/vue-query'
import { loadDraft } from '../onboarding.service'

export const onboardingDraftKeys = {
    all: ['onboarding-draft'] as const,
    details: () => [...onboardingDraftKeys.all, 'detail'] as const,
    detail: (siteId: MaybeRefOrGetter<SiteID>) => [
         ...onboardingDraftKeys.details(),
        siteId,
    ] as const,
}

export function useOnboardingDraftDetailQuery(siteId: MaybeRefOrGetter<SiteID>, options: { enabled?: MaybeRefOrGetter<boolean> } = {}) {
    return useQuery({
        queryKey: onboardingDraftKeys.all,
        queryFn: async () => {
            return await loadDraft(toValue(siteId))
        },
        enabled: options.enabled,
        staleTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    })
}